import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    trigger: {
        alignSelf: "center"
    }
});
export default stylesheet;
